<template>
    <div class="Details">
    <section>
      

      
        <div class="columns">
            <div class="column">
            <div class="block box">
              
              <h4 class="title is-5">
                Integrate into your existing systems</h4>
              <div class="block">
                  Here is your API KEY. Need help integrating into your system or 3rd party apps? Ask at support@metatext.io
                </div> 
              <pre>{{getApiKey()}}</pre>
            </div>
            <div class="block box">
              
              <b-tabs type="is-boxed" size="is-small" class="block" >
                <b-tab-item v-for="code in ['Inference', 'Inference batch']" :key="code.name">
                    <template #header>
                        <!--b-icon size="is-small" icon="information-outline"></b-icon-->
                        <h4 class="title is-5">{{ code }} endpoint</h4>
                    </template>
                    
                    <div v-if="code == 'Inference'">
                      <h4 class="subtitle is-6">
                        Send one single text by request and receive the predicted label and confidence score.
                      </h4>
                      <span class="subtitle is-7">URL</span>
                      <pre><b>POST</b> {{ getInferenceUrl() }}</pre>
                      <span class="subtitle is-7">Request Parameters</span>
                      <pre><b>Text (string)</b>: Text to inference</pre>
                      <span class="subtitle is-7">Response</span>
                      <pre><b>Prediction label (string)</b>: Predicted label with the high confidence value<br><b>Confidence value (float)</b>: Confidence value</pre>
                      <span class="subtitle is-7">Response example</span>
                      <pre>{"prediction":"A",
"confidence":0.8284599730460649}</pre>
                    </div>

                    <div v-if="code == 'Inference batch'">
                      <h4 class="subtitle is-6">
                        Send a batch of texts by request (bulk request) and receive the list of predicted labels and confidence scores.</h4>

                      <span class="subtitle is-7">URL</span>
                      <pre><b>POST</b> {{ model_url_batch }}</pre>
                      <span class="subtitle is-7">Request Parameters</span>
                      <pre><b>Text (list[string])</b>: List of texts to inference</pre>
                      
                      <span class="subtitle is-7">Response</span>
                      <pre><b>Results (list[dict[string, float]])</b>: 
      <b>Prediction label (string)</b>: Predicted label with the high confidence value
      <b>Confidence value (float)</b>: Confidence value</pre>
                      <span class="subtitle is-7">Response example</span>
                      <pre>{"results":
  [{"prediction":"A",
  "confidence":0.9146022845997649},
  {"prediction":"B",
  "confidence":0.8486356826097114}]}  </pre>

                      
                    </div>
                </b-tab-item>
              </b-tabs>
            </div>
            
            <div class="block box">
              <h4 class="title is-5">Request example</h4>
              <b-tabs type="is-boxed" size="is-small" class="block" >
                <b-tab-item v-for="code in code_examples" :key="code.name">
                    <template #header>
                        <!--b-icon size="is-small" icon="information-outline"></b-icon-->
                        <span> {{ code.name }}  </span>
                    </template>
                    
                    <pre v-if="code.name == 'Python'">import requests

url = "{{getInferenceUrl()}}"

payload = "{
    \"text\": \"O produto é bom, chegou no prazo estimado. Só tenho elogios!\"
}"
headers = {
    'content-type': "application/json",
    'x-api-key': "{{getApiKey()}}"
    }

response = requests.request("POST", url, data=payload, headers=headers)

print(response.text)</pre>

                    <pre v-if="code.name == 'NodeJS'">var axios = require("axios").default;

var options = {
  method: 'POST',
  url: '{{getInferenceUrl()}}',
  headers: {
    'content-type': 'application/json',
    'x-api-key': '{{getApiKey()}}'
  },
  data: {text: 'O produto é bom, chegou no prazo estimado. Só tenho elogios!'}
};

axios.request(options).then(function (response) {
	console.log(response.data);
}).catch(function (error) {
	console.error(error);
}
                    </pre>
                    <pre v-if="code.name == 'cURL'">curl --request POST \
	--url {{getInferenceUrl()}} \
	--header 'content-type: application/json' \
	--header 'x-api-key: {{getApiKey()}}' \
	--data '{
    "text": "O produto é bom, chegou no prazo estimado. Só tenho elogios!"
}'</pre>
                </b-tab-item>
            </b-tabs>
            </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
            
            
            </div>
        </div>
        
        
    </section>

    </div>
</template>
<script>
import firebase from 'firebase/compat/app';

export default {
     props: ["model","modelId", "currentUser"],
     name: "API",
     data: function() {
    return {
        model_url: 'https://api.metatext.ai/inference/' + this.modelId,
        model_url_batch: 'https://api.metatext.ai/inference-batch/' + this.modelId,
        model_hub_url: 'https://api.metatext.ai/hub-inference/' + this.modelId,
        api_key: 'YOUR_API_KEY',
        all_users_api_key: 'Z0CDIgI42M5hggX0bpBB61UZswN4NiHNaqqsFIWd',
        text: "",
        result: '',
        isLoading: false,
        code_examples: [
            {name: "cURL", code: "code", is_active:1},
            {name: "Python", code: "code"},
            {name: "NodeJS", code: "code"},
            /*{name: "GO", code: "code"},
            {name: "Rust", code: "code"},
            {name: "Java", code: "code"},
            {name: "Ruby", code: "code"},
            {name: "R", code: "code"},
            {name: "Julia", code: "code"},*/
        ]
      }},
     computed: {
       items() {
         return this.$store.state.currentModelItems;
       }
     },
     methods: {
         getApiKey(){
            if(!this.currentUser){
              return '[SIGN UP TO GET YOUR API]'
            } else {
              return this.all_users_api_key
            }
         },
         getInferenceUrl() {
          if (this.model.hub_only == true){
            return this.model_hub_url
          } else {
            return this.model_url
          }
         },
         copyURL(data) {
            
            data.select();
            document.execCommand("copy");
        },
        async invoke() {
          this.isLoading = true
          // this.$buefy.notification.open(`Calling model API`)
          //this.$buefy.notification.open('Request time: '+parseFloat(response_time).toFixed(3)+' s.')
          const payload = {
            userId: firebase.auth().currentUser.uid, 
            modelId: this.model.id, 
            text: this.text,
            hub: (this.model.hub_only == true),
            hub_prompt_template: this.model.gpt_prompt
          }          
          
          const result = await this.$store.dispatch("getModelInference", payload);
          
          const toUpdate = {
                userId: firebase.auth().currentUser.uid, 
                update: {
                    predictionsTotal: (this.currentUser.predictionsTotal == undefined ? 0 : this.currentUser.predictionsTotal)
                }
          }

          this.$store.dispatch("updateModelPredictionsTotal", 
            toUpdate
          )

          this.result = result
          this.isLoading = false
        }
     },
     created() {
       // console.log(this.pageId)
       //this.$store.dispatch("displayModelDetails", this.boardId);
       this.training = true
       this.options = {},
       this.currentTab = "details"
       // this.model_url = 'https://api.metatext.io/v1/model/' + this.model.id
       // this.series = [44, 55, 41, 17, 15]
     }
   };
</script>